import React from "react";
import { IconButton, InputAdornment, TextField } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
export { matchesTabSearch } from "../modules/playEngineTabSearch";

/** A local search field shared by the six playEngine editor tabs. */
export default function PlayEngineTabSearch({ value, onChange }) {
  return (
    <div style={{ flex: "0 0 auto", padding: "8px 10px", backgroundColor: "#3a3a41", borderBottom: "1px solid #3a3a3f" }}>
      <TextField
        fullWidth
        size="small"
        variant="outlined"
        placeholder="Search"
        aria-label="Search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event) => event.stopPropagation()}
        InputProps={{
          style: { color: "#eee", backgroundColor: "#212226", fontSize: 13 },
          startAdornment: <InputAdornment position="start"><SearchIcon style={{ color: "#8a8d93", fontSize: 18 }} /></InputAdornment>,
          endAdornment: value ? (
            <InputAdornment position="end">
              <IconButton size="small" aria-label="Clear search" onClick={() => onChange("")}>
                <ClearIcon style={{ color: "#8a8d93", fontSize: 16 }} />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
      />
    </div>
  );
}
